import { useEffect } from "react";

export default function NuclearExplosion({ show, onFinish }) {
  useEffect(() => {
    if (show) {
      const t = setTimeout(() => onFinish?.(), 18000);
      return () => clearTimeout(t);
    }
  }, [show]);

  if (!show) return null;

  return (
    <>
      <style>{`
        .nuke-overlay {
          position: fixed;
          inset: 0;
          z-index: 99999999;
          background: radial-gradient(circle at center, #ffb347 0%, #000 80%);
          overflow: hidden;
        }

        /* FLASH BLANCO */
        .nuke-flash {
          position: absolute;
          inset: 0;
          background: white;
          animation: flash 0.5s ease-out forwards;
          z-index: 10;
        }

        /* IMAGEN BASE */
        .nuke-image {
          position: absolute;
          inset: 0;
          background: url("https://ichef.bbci.co.uk/ace/ws/800/cpsprodpb/2D51/production/_93810611_nuclearsol.jpg.webp") center / cover no-repeat;
          filter: contrast(1.3) saturate(1.5);
          animation: zoom 6s ease-out forwards;
        }

        /* BRILLO CENTRAL */
        .glow {
          position: absolute;
          inset: 0;
          background:
            radial-gradient(circle at center,
              rgba(255,200,120,0.8),
              rgba(255,120,0,0.4),
              transparent 60%);
          mix-blend-mode: screen;
          animation: pulse 2s infinite alternate;
        }

        /* RAYOS DE LUZ */
        .rays {
          position: absolute;
          inset: -50%;
          background:
            repeating-conic-gradient(
              from 0deg,
              rgba(255,255,255,0.15) 0deg,
              rgba(255,255,255,0.05) 8deg,
              transparent 15deg
            );
          animation: rotate 20s linear infinite;
          mix-blend-mode: overlay;
        }

        /* ONDA EXPANSIVA */
        .shockwave {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          border: 3px solid rgba(255,255,255,0.6);
          transform: translate(-50%, -50%);
          animation: shock 3s ease-out forwards;
        }

        /* PARTICULAS */
        .particles {
          position: absolute;
          inset: 0;
          pointer-events: none;
        }

        .particle {
          position: absolute;
          width: 4px;
          height: 4px;
          background: rgba(180,120,60,0.9);
          border-radius: 50%;
          animation: fall linear infinite;
        }

        @keyframes flash {
          from { opacity: 1; }
          to { opacity: 0; }
        }

        @keyframes zoom {
          from { transform: scale(1); }
          to { transform: scale(1.15); }
        }

        @keyframes pulse {
          from { opacity: 0.6; }
          to { opacity: 1; }
        }

        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        @keyframes shock {
          from { width: 10px; height: 10px; opacity: 1; }
          to { width: 1600px; height: 1600px; opacity: 0; }
        }

        @keyframes fall {
          from {
            transform: translateY(-20px);
            opacity: 1;
          }
          to {
            transform: translateY(110vh);
            opacity: 0;
          }
        }
      `}</style>

      <div className="nuke-overlay">
        <div className="nuke-flash" />
        <div className="nuke-image" />
        <div className="glow" />
        <div className="rays" />
        <div className="shockwave" />

        <div className="particles">
          {Array.from({ length: 120 }).map((_, i) => (
            <span
              key={i}
              className="particle"
              style={{
                left: Math.random() * 100 + "%",
                animationDuration: 2 + Math.random() * 4 + "s",
                animationDelay: Math.random() * 2 + "s",
              }}
            />
          ))}
        </div>
      </div>
    </>
  );
}
